export const AdminTableHeaders = ["name-label", "email", "delete"];
